<vw-header-padding-safe-area></vw-header-padding-safe-area>
<div class="px-4 pb-28">
  <div class="flex items-baseline justify-between pb-3">
    <h2 class="flex items-center w-auto gap-2 text-[#062825] text-[32px] font-semibold pb-3">{{"profile.title" |
      translate}}</h2>
    <vw-settings-button></vw-settings-button>
  </div>
  <div>
    <div class="flex items-center flex-col gap-8 w-auto mb-4">
      <!-- Carte Premium : le profil est l'endroit attendu pour gerer un
           abonnement, et la surface etait deja reservee a ce type de contenu.

           Abonne et non-abonne ne partagent pas la meme carte. Un « ✓ » discret
           ne recompense pas un achat : quand on paie, on doit voir qu'on est
           membre. La gestion de l'abonnement reste accessible d'un geste. -->
      <!-- Premium fermé : ni offre ni abonnement à gérer, la carte disparaît. -->
      @if (premiumService.premiumEnabled()) {
      <div class="w-full">
        @if (!premiumService.ready()) {
          <!-- État inconnu : un abonné ne doit pas voir l'offre payante
               clignoter le temps que le jeton soit lu. -->
          <vw-skeleton-loader [width]="'100%'" [height]="'84px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
        } @else if (premiumService.isPremium()) {
        <div
          class="w-full rounded-xl bg-gradient-to-br from-[#0B3A33] to-[#125046] px-4 py-4 shadow-lg cursor-pointer"
          (click)="openPremium()"
        >
          <div class="flex items-center gap-3">
            <span
              class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#F79400] to-[#F0C97A]"
            >
              <svg viewBox="0 0 24 24" class="h-5 w-5 text-white" fill="currentColor" aria-hidden="true">
                <path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8L12 2z" />
              </svg>
            </span>
            <div class="min-w-0 flex-1">
              <p class="text-[11px] font-semibold uppercase tracking-wide text-[#F0C97A]">
                {{ 'premium.profile.member-badge' | translate }}
              </p>
              <!-- Depuis quand, et ce qui se passe ensuite : les deux seules
                   questions qu'un abonne se pose en voyant ce bloc. -->
              @if (premiumSinceLabel) {
                <p class="text-base font-semibold text-white leading-tight">
                  {{ 'premium.profile.member-since' | translate: { date: premiumSinceLabel } }}
                </p>
              } @else {
                <p class="text-base font-semibold text-white leading-tight">
                  {{ 'premium.profile.member-title' | translate }}
                </p>
              }
              @if (premiumNextLabel) {
                <p class="text-[11px] text-white/70 mt-0.5">{{ premiumNextLabel }}</p>
              }
            </div>
          </div>

          <div class="mt-3 flex items-center justify-between rounded-lg bg-white/10 px-3 py-2">
            <span class="text-sm text-white">
              {{ 'premium.profile.manage' | translate }}
            </span>
            <span class="text-white text-lg leading-none">&rsaquo;</span>
          </div>
        </div>
        } @else {
        <vw-card customClasses="bg-white">
          <div
            class="bg-white shadow-lg py-4 px-4 rounded-xl flex items-center justify-between cursor-pointer"
            (click)="openPremium()"
          >
            <div class="min-w-0 pr-3">
              <span class="text-sm text-primary-dark font-semibold">
                {{ 'premium.profile.title' | translate }}
              </span>
              <p class="text-xs text-[#9BA6A1] mt-0.5">
                {{ 'premium.profile.subtitle' | translate }}
              </p>
            </div>
            <span class="text-primary-dark text-lg leading-none">&rsaquo;</span>
          </div>
        </vw-card>
        }
      </div>
      }
      <div class="w-full">
        @if (user && !isLoading) {
        <vw-card customClasses="bg-white">
          <div class="bg-white shadow-lg py-4 pl-4 pr-2 rounded-xl flex items-start gap-6">
            <div class="w-24 h-24">
              <vw-img [rounded]="true" class="w-24 h-24" [src]="userPictureUrl"></vw-img>
            </div>
            <div class="w-account">
              <div class="relative flex items-center justify-between w-full">
                <h3 class="text-xl text-primary-dark font-semibold pb-2">{{"profile.infos.title" | translate}}</h3>
                <div class="absolute right-0 top-0 items-end justify-end ">
                  <vw-icon-svg (click)="editUserMode = true" iconUrl="/assets/svg/square-pen.svg"
                    additionalClasses="cursor-pointer" width="24px" height="24px"></vw-icon-svg>
                </div>
              </div>
              <div class="w-full pb-3">
                <p class="text-[#9BA6A1] text-xs">{{"profile.infos.pseudo" | translate}}</p>
                <p class="text-sm text-primary-dark">{{user.pseudo}}</p>
              </div>
              <div class="w-full pb-3">
                <p class="text-[#9BA6A1] text-xs">{{"profile.infos.joined" | translate}}</p>
                <p class="text-sm text-primary-dark">{{user.registrationDate | date: 'MM/yyyy' }}</p>
              </div>
              <div class="w-full pb-3">
                <p class="text-[#9BA6A1] text-xs">{{"profile.infos.user-type" | translate}}</p>
                <p class="text-sm text-primary-dark">{{'profile.infos.user-types.' + user.expertise | translate}}</p>
              </div>
              <div class="w-full">
                <p class="text-[#9BA6A1] text-xs">{{"profile.infos.language" | translate}}</p>
                <p class="text-sm text-primary-dark">{{"profile.infos.languages." + user.preferredLanguage | translate}}
                </p>
              </div>
            </div>
          </div>
        </vw-card>
        }
        @if (isLoading) {
        <vw-skeleton-loader [width]="'100%'" [height]="'248px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
        }
      </div>
      <div class="w-full">
        <vw-card customClasses="bg-white">
          <div class="bg-white shadow-lg py-4 px-4 rounded-xl flex items-center justify-between cursor-pointer"
            (click)="notificationPrefsMode = true">
            <span class="text-sm text-primary-dark font-semibold">{{
              "profile.notification-preferences.entry" | translate }}</span>
            <span class="text-primary-dark text-lg leading-none">&rsaquo;</span>
          </div>
        </vw-card>
      </div>
      <!-- Activation apres paiement : l'utilisateur revient du navigateur, le
           webhook Stripe met quelques secondes a nous parvenir -->
      @if (activatingPremium) {
      <div class="w-full rounded-2xl bg-[#F2FAF5] px-4 py-3 text-center text-sm text-[#317756]">
        {{ 'premium.paywall.activating' | translate }}
      </div>
      }

      <div class="w-full relative">
        <div class="absolute top-1 right-3 rotate-6 flex gap-1 text-primary-900">
          <vw-corner-left-down-icon class="mt-1.5"></vw-corner-left-down-icon>
          <span class="mb-12 uppercase text-sm font-medium" style="font-family: 'jost'">Coming
            soon</span>
        </div>
        <h2 class="text-[#062825] text-2xl font-semibold pb-3 opacity-30">
          {{ "profile.level" | translate}}
        </h2>
        <div class="bg-white shadow-lg p-3 rounded-xl opacity-30">
          <div class="flex items-center gap-2 w-full pb-3">
            <vw-icon-svg iconUrl="/assets/svg/leafonly.svg" additionalClasses="cursor-pointer" width="20px"
              height="20px"></vw-icon-svg>
            <p class="text-base text-primary-dark">Jeune pousse</p>
          </div>
          <vw-progress-bar [progress]="progress"></vw-progress-bar>
        </div>

      </div>
      <div class="w-full overflow-hidden">
        <h2 class="text-[#062825] text-2xl font-semibold pb-3">{{ "profile.garden.title" | translate }}</h2>
        @if (!isLoading) {
        <div class="flex items-center flex-wrap gap-y-4 w-full">
          @for (address of userAddresses; track address) {
          <vw-user-address-card class="w-full" [address]="address" (closeEditAddressToast)="onCloseEditAddressToast()">
          </vw-user-address-card>
          }
        </div>
        }
        @if (isLoading) {
        <vw-skeleton-loader [width]="'100%'" [height]="'160px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
        }
      </div>
      <div class="w-full overflow-hidden">
        <!-- btn delete account -->
        <vw-button  (onClick)="onDeleteAccount()" [look]="'danger'" [iconTemplate]="iconTemplate"
                   [label]="'profile.delete-account.title'" [iconPosition]="'right'"
                   customClass="text-center m-auto w-auto z-[999] relative">
          <ng-template #iconTemplate>
            <vw-delete-icon></vw-delete-icon>
          </ng-template>
        </vw-button>
      </div>
    </div>
  </div>
</div>

<vw-edit-user-toast [isOpen]="editUserMode" [user]="user" (close)="onCloseEditUser($event)"></vw-edit-user-toast>
<vw-notification-preferences-toast [isOpen]="notificationPrefsMode"
  (close)="notificationPrefsMode = false"></vw-notification-preferences-toast>
<vw-confirm-toast [isOpen]="showConfirmDelete" [confirmMessage]="'profile.delete-account.description'"
  [confirmYes]="'profile.delete-account.confirm'" [confirmNo]="'profile.delete-account.cancel'"
  (confirm)="onConfirmDelete($event)" (cancel)="showConfirmDelete = false"></vw-confirm-toast>

<!--
<vw-custom-form  [isOpen]="editUserMode"
[formConfig]="formConfig"
(closeBottomSheet)="closeBottomSheet()"
(submitForm)="handleFormSubmit($event)"></vw-custom-form> -->

<vw-premium-toast
  [isOpen]="premiumPaywallMode"
  [source]="'profile_card'"
  (close)="premiumPaywallMode = false"
></vw-premium-toast>

<vw-subscription-toast
  [isOpen]="subscriptionMode && premiumService.premiumEnabled()"
  (close)="onSubscriptionToastClosed($event)"
></vw-subscription-toast>

<vw-downgrade-toast
  [isOpen]="premiumService.justDowngraded()"
  (close)="onDowngradeAcknowledged($event)"
></vw-downgrade-toast>
